import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

import { Badge as MUIBadge } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

import ListAltRoundedIcon from '@material-ui/icons/ListAltRounded'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'

import { fetchPlanServicesList as fetchPlanCpfServicesList } from 'redux/planCpfServices/actions'
import { fetchPlanServicesList as fetchPlanCnpjServicesList } from 'redux/planCnpjServices/actions'
import { getList, getListBlacklist, getListBatch } from 'services/apiMotorBgc'

import { BATCH_STATUS } from 'utils/constants/batchStatus'
import analysisStatusConstants from 'utils/constants/analysisStatus'
import serviceStatusConstants from 'utils/constants/serviceStatus'
import reportError from 'utils/errorReporter'

const Badge = withStyles({
  badge: {
    backgroundColor: '#ccc',
    right: -30,
    transform: 'scale(1) translate(50%, -10%)',
  },
})(MUIBadge)

const BADGE_MAX = 999999999

export default function ({ currentPath }) {
  const dispatch = useDispatch()

  const userId = useSelector((state) => state.auth.sub)
  const apiKey = useSelector((state) => state.auth.api_key)
  const panelEnv = useSelector((state) => state.auth.panelEnv)

  const [totalProcessing, setTotalProcessing] = useState(null)
  const [totalGeral, setTotalGeral] = useState(null)
  const [totalApproveds, setTotalApproveds] = useState(null)
  const [totalApprovedsPep, setTotalApprovedsPep] = useState(null)
  const [totalApprovedsProcessesUnclassified, setTotalApprovedsProcessesUnclassified] = useState(null)
  const [totalApprovedsProcessesWhitelist, setTotalApprovedsProcessesWhitelist] = useState(null)
  const [totalApprovedsHasContingency, setTotalApprovedsHasContingency] = useState(null)
  const [totalReproveds, setTotalReproveds] = useState(null)
  const [totalInexistents, setTotalInexistents] = useState(null)
  const [totalBlacklists, setTotalBlacklists] = useState(null)
  const [totalPending, setTotalPending] = useState(null)
  const [totalBatchProcessing, setTotalBatchProcessing] = useState(null)
  const [totalBatchProcessed, setTotalBatchProcessed] = useState(null)

  const listBlacklist = async () => {
    let res = null
    try {
      res = await getListBlacklist(
        apiKey,
        userId,
        panelEnv,
      )
    } catch (err) {
      reportError(err, 'Erro ao listar bloqueados')
      return
    }

    setTotalBlacklists(parseInt(res.headers['x-total'], 10))
  }

  const listDocs = async (type, options = {}) => {
    let res = null
    try {
      res = await getList(
        apiKey,
        userId,
        panelEnv,
        {
          totalsOnly: true,
          analysisStatus: options.analysisStatus,
          hasPep: options.hasPep,
          hasProcessesUnclassified: options.hasProcessesUnclassified,
          hasProcessesWhitelist: options.hasProcessesWhitelist,
          hasContingency: options.hasContingency,
          hasContingencyRevision: options.hasContingencyRevision,
          status: options.status,
          slowProcessing: options.slowProcessing,
          isTakingTimeToProcess: options.isTakingTimeToProcess,
          hasManualDerivation: options.hasManualDerivation,
          inexistent: options.inexistent,
        },
      )
    } catch (err) {
      reportError(err, `Erro ao listar ${panelEnv.toUpperCase()}s`)
      return
    }

    switch (type) {
      case 'processing': setTotalProcessing(parseInt(res.headers['x-total'], 10)); break
      case 'total_geral': setTotalGeral(parseInt(res.headers['x-total'], 10)); break
      case 'approveds': setTotalApproveds(parseInt(res.headers['x-total'], 10)); break
      case 'approvedsPep': setTotalApprovedsPep(parseInt(res.headers['x-total'], 10)); break
      case 'approvedsProcessesUnclassified': setTotalApprovedsProcessesUnclassified(parseInt(res.headers['x-total'], 10)); break
      case 'approvedsProcessesWhitelist': setTotalApprovedsProcessesWhitelist(parseInt(res.headers['x-total'], 10)); break
      case 'approvedsHasContingency': setTotalApprovedsHasContingency(parseInt(res.headers['x-total'], 10)); break
      case 'reproveds': setTotalReproveds(parseInt(res.headers['x-total'], 10)); break
      case 'inexistents': setTotalInexistents(parseInt(res.headers['x-total'], 10)); break
      case 'pending': setTotalPending(parseInt(res.headers['x-total'], 10)); break
      default:
        break
    }
  }

  const listBatchCpfDoc = async (type, options = {}) => {
    let res = null
    try {
      res = await getListBatch(
        apiKey,
        userId,
        panelEnv,
        {
          totalsOnly: true,
          status: options.status,
        },
      )
    } catch (err) {
      reportError(err, 'Erro ao listar lotes')
      return
    }

    switch (type) {
      case 'processing': setTotalBatchProcessing(parseInt(res.headers['x-total'], 10)); break
      case 'processed': setTotalBatchProcessed(parseInt(res.headers['x-total'], 10)); break
      default:
        break
    }
  }

  const calculateTotals = () => {
    listDocs('processing', {
      status: serviceStatusConstants.SERVICE_STATUS.processing,
      isTakingTimeToProcess: false,
    })
    listDocs('total_geral', {
      analysisStatus: null,
    })
    listDocs('approveds', {
      analysisStatus: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.approved,
    })
    listDocs('approvedsPep', {
      analysisStatus: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.approved,
      hasPep: true,
    })
    listDocs('approvedsProcessesUnclassified', {
      analysisStatus: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.approved,
      hasProcessesUnclassified: true,
    })
    listDocs('approvedsProcessesWhitelist', {
      analysisStatus: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.approved,
      hasProcessesWhitelist: true,
    })
    listDocs('approvedsHasContingency', {
      analysisStatus: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.approved,
      hasContingency: true,
    })
    listDocs('reproveds', {
      analysisStatus: analysisStatusConstants.SERVICE_ANALYSIS_STATUS_TYPE.reproved,
    })
    listDocs('inexistents', {
      inexistent: true,
    })
    listBlacklist()
    listDocs('pending', {
      status: serviceStatusConstants.SERVICE_STATUS.processing,
      isTakingTimeToProcess: true,
      hasManualDerivation: false,
    })
    listBatchCpfDoc('processing', {
      status: BATCH_STATUS.processing,
    })
    listBatchCpfDoc('processed', {
      status: BATCH_STATUS.processed,
    })
  }

  useEffect(() => {
    dispatch(fetchPlanCpfServicesList())
    dispatch(fetchPlanCnpjServicesList())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setTimeout(calculateTotals, 3 * 1000)

    const intervalId = setInterval(calculateTotals, 120 * 1000)
    return () => clearInterval(intervalId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderNavConsults = () => {
    return (
      <li>
        <div className="category">
          <ListAltRoundedIcon />
          Consultas
        </div>
        <ul>
          <li>
            <Link
              className={(currentPath === `/${panelEnv}/total`) ? 'selected' : ''}
              to={`/${panelEnv}/total`}
            >
              <Badge badgeContent={totalGeral} color="primary" max={BADGE_MAX}>
                Total
              </Badge>
            </Link>
          </li>

          <li>
            <Link
              className={(currentPath === `/${panelEnv}/processing`) ? 'selected' : ''}
              to={`/${panelEnv}/processing`}
            >
              <Badge badgeContent={totalProcessing} color="primary" max={BADGE_MAX}>
                Processando
              </Badge>
            </Link>
          </li>

          <li>
            <Link
              className={(currentPath === `/${panelEnv}/approved`) ? 'selected' : ''}
              to={`/${panelEnv}/approved`}
            >
              <Badge badgeContent={totalApproveds} color="primary" max={BADGE_MAX}>
                Aprovados
              </Badge>
            </Link>
          </li>
          <li>
            <Link
              className={(currentPath === `/${panelEnv}/approved-pep`) ? 'selected' : ''}
              to={`/${panelEnv}/approved-pep`}
            >
              <Badge badgeContent={totalApprovedsPep} color="primary" max={BADGE_MAX}>
                Aprovados - PEP
              </Badge>
            </Link>
          </li>
          <li>
            <Link
              className={(currentPath === `/${panelEnv}/approved-processes-whitelist`) ? 'selected' : ''}
              to={`/${panelEnv}/approved-processes-whitelist`}
            >
              <Badge badgeContent={totalApprovedsProcessesWhitelist} color="primary" max={BADGE_MAX}>
                Aprovados - Processos Whitelist
              </Badge>
            </Link>
          </li>
          <li>
            <Link
              className={(currentPath === `/${panelEnv}/approved-processes-unclassified`) ? 'selected' : ''}
              to={`/${panelEnv}/approved-processes-unclassified`}
            >
              <Badge badgeContent={totalApprovedsProcessesUnclassified} color="primary" max={BADGE_MAX}>
                Aprovados - Processos sem Classificação
              </Badge>
            </Link>
          </li>
          <li>
            <Link
              className={(currentPath === `/${panelEnv}/approved-contingency`) ? 'selected' : ''}
              to={`/${panelEnv}/approved-contingency`}
            >
              <Badge badgeContent={totalApprovedsHasContingency} color="primary" max={BADGE_MAX}>
                Aprovados - Com contigência
              </Badge>
            </Link>
          </li>

          <li>
            <Link
              className={(currentPath === `/${panelEnv}/reproved`) ? 'selected' : ''}
              to={`/${panelEnv}/reproved`}
            >
              <Badge badgeContent={totalReproveds} color="primary" max={BADGE_MAX}>
                Reprovados
              </Badge>
            </Link>
          </li>

          <li>
            <Link
              className={(currentPath === `/${panelEnv}/inexistent`) ? 'selected' : ''}
              to={`/${panelEnv}/inexistent`}
            >
              <Badge badgeContent={totalInexistents} color="primary" max={BADGE_MAX}>
                Inexistentes
              </Badge>
            </Link>
          </li>

          <li>
            <Link
              className={(currentPath === `/${panelEnv}/blocked`) ? 'selected' : ''}
              to={`/${panelEnv}/blocked`}
            >
              <Badge badgeContent={totalBlacklists} color="primary" max={BADGE_MAX}>
                Bloqueados
              </Badge>
            </Link>
          </li>

          {/* BV: desativado pois nao existe essa funcionalidade nesse painel
          <li>
            <Link
              className={(currentPath === `/${panelEnv}/with-error`) ? 'selected' : ''}
              to={`/${panelEnv}/with-error`}
            >
              <Badge badgeContent={totalError} color="primary" max={BADGE_MAX}>
                Com Erro
              </Badge>
            </Link>
          </li>
          */}

          <li>
            <Link
              className={(currentPath === `/${panelEnv}/pending`) ? 'selected' : ''}
              to={`/${panelEnv}/pending`}
            >
              <Badge badgeContent={totalPending} color="primary" max={BADGE_MAX}>
                Pendentes
              </Badge>
            </Link>
          </li>
        </ul>
      </li>
    )
  }

  const renderNavBatchConsults = () => {
    return (
      <li>
        <div className="category">
          <ListAltRoundedIcon />
          Consultas em Lote
        </div>
        <ul>
          <li>
            <Link
              className={(currentPath === `/${panelEnv}/batch/processing`) ? 'selected' : ''}
              to={`/${panelEnv}/batch/processing`}
            >
              <Badge badgeContent={totalBatchProcessing} color="primary" max={BADGE_MAX}>
                Processando
              </Badge>
            </Link>
          </li>

          <li>
            <Link
              className={(currentPath === `/${panelEnv}/batch/processed`) ? 'selected' : ''}
              to={`/${panelEnv}/batch/processed`}
            >
              <Badge badgeContent={totalBatchProcessed} color="primary" max={BADGE_MAX}>
                Processados
              </Badge>
            </Link>
          </li>
        </ul>
      </li>
    )
  }

  const renderNavConfigs = () => {
    return (
      <li>
        <div className="category second-category">
          <SettingsOutlinedIcon />
          Configurações
        </div>
        <ul>
          {/* BV: nao exibir
          <li>
            <Link className={(currentPath === `/${panelEnv}/plan`) ? 'selected' : ''} to={`/${panelEnv}/plan`}>
              Plano
            </Link>
          </li>
          */}
        </ul>
      </li>
    )
  }

  return (
    <nav>
      <ul>
        {renderNavConsults()}
        {renderNavBatchConsults()}
        {renderNavConfigs()}
      </ul>
    </nav>
  )
}
